module.exports = __webpack_public_path__ + "img/history-solid.f28f8109.svg";